import React, { useContext, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import { FaUserCircle } from "react-icons/fa"; // Import user icon
import "../styles/settings/profile.css";
import Toast from '../components/Toast';

const ProfileSettings = () => {
  const { currentUser, updateUserProfile } = useContext(AuthContext); // ✅ Get updateUserProfile
  const [isEditing, setIsEditing] = useState(false);
  const [avatar, setAvatar] = useState(null); // ✅ Stores selected file
  const [preview, setPreview] = useState(currentUser?.profileImage || ""); // ✅ Stores image preview URL
  const [loading, setLoading] = useState(false); // ✅ Loading state for button
  const [userData, setUserData] = useState({
    email: currentUser?.email || "",
    username: currentUser?.username || "",
    phone: currentUser?.phoneNumber || "",
    location: currentUser?.location || "",
  });
   const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("info");

  const showToast = (message, type = "info") => {
    setToastMessage(message);
    setToastType(type);
  };

  // ✅ Handle Edit Mode Toggle
  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  // ✅ Handle Input Changes
  const handleChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  // ✅ Handle Avatar Upload (Preview and File Storage)
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setAvatar(file); // Store the file for upload
      setPreview(URL.createObjectURL(file)); // Show preview
    }
  };

  // ✅ Handle Profile Update (Saves Data & Image)
  const handleSaveChanges = async () => {
    setLoading(true);
    try {
      const response = await updateUserProfile(userData, avatar);
      if (response.success) {
        showToast(" Updated successfully", "success");
        setIsEditing(false);
      } else {
        showToast(response.error || "Update failed", "error");
      }
    } catch (error) {
      showToast(" Unexpected error occurred. Please try again.", "error");
    }
    setLoading(false);
  };

  return (
    <div className="settings-section">
       {toastMessage && (
        <Toast
          message={toastMessage}
          type={toastType}
          onClose={() => setToastMessage("")}
        />
      )}
      {/* Profile Avatar Section */}
      <div className="profile-avatar">
        {preview ? (
          <img src={preview} alt="Profile" className="uploaded-avatar" />
        ) : (
          <FaUserCircle className="default-avatar" />
        )}
        {isEditing && (
          <label className="upload-button">
            Upload Your Picture
            <input type="file" accept="image/*" onChange={handleFileChange} />
          </label>
        )}
      </div>

      {/* Profile Details Form */}
      <div className="profile-form">
        {Object.entries(userData).map(([key, value]) => (
          <div className="profile-row" key={key}>
            <label className="profile-label">{key.charAt(0).toUpperCase() + key.slice(1)}</label>
            <input
              type="text"
              name={key}
              value={value}
              onChange={handleChange}
              disabled={!isEditing}
              className={`profile-input ${isEditing ? "editable" : ""}`}
            />
          </div>
        ))}
      </div> 

      {/* Action Buttons */}
      <div className="profile-actions">
        {isEditing ? (
          <>
            <button onClick={handleSaveChanges} className="save-button" disabled={loading}>
              {loading ? "Saving..." : "Save Changes"}
            </button>
            <button className="cancel-button" onClick={() => setIsEditing(false)} disabled={loading}>
              Cancel
            </button>
          </>
        ) : (
          <button onClick={handleEditToggle} className="edit-button">Edit Profile</button>
        )}
      </div>
    </div>
  );
};

export default ProfileSettings;
